import { useQuery } from "@tanstack/react-query";

import feedbackService from "@services/feedback.service";
import { FEEDBACK_OPTIONS_QUERY_KEY, QUERY_CACHE_LONG_EXPIRATION_MS } from "@config/query";

export function useFeedbackOptions() {
  const { data, isLoading } = useQuery({
    queryKey: [FEEDBACK_OPTIONS_QUERY_KEY],
    queryFn: () => feedbackService.getFeedbackOptions(),
    staleTime: QUERY_CACHE_LONG_EXPIRATION_MS,
  });

  return {
    feedbackOptions: data ?? [],
    isLoadingOptions: isLoading,
  };
}
